import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Pager,
  Paging,
  StateStoring,
  Button,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import axios from "axios";
import swal from "sweetalert";
import Guid from "devextreme/core/guid";
import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button1 from "@material-ui/core/Button";
import { api_path } from "../../shared.js";
import Select from "react-select";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import DateBox from "devextreme-react/date-box";
import RadioButton from "../RadioButton3.jsx";
import Modal from "react-bootstrap/Modal";
import dateFormat from "dateformat";
import OrderLogDataView from "./OrderLogItemView";
import useDeviceSize from "../../hooks/useDeviceSize";
export function JobManagmentReportDataGrid(props) {
  const [width, height] = useDeviceSize();
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const [getOrderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [selectOrderStatus, setSelectOrderStatus] = useState([]);
  const [REMARK, SET_REMARK] = useState("");
  const [getJobManagementReportDataSource, setJobManagementReportDataSource] =
    useState();
  const gridRef = useRef(null);
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);
  const classes = useStyles();
  const [getLoadGrid, setLoadGrid] = useState();
  const [getResult, setResult] = useState("");
  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);
  const [getCS, setCS] = useState([]);
  const [CSList, setCSList] = useState([]);
  const [selectCS, setSelectCS] = useState([]);
  const [showLog, setShowLog] = useState(false);
  const handleCloseLog = () => setShowLog(false);
  const handleShowLog = () => setShowLog(true);
  const [showComment, setShowComment] = useState(false);
  const handleCloseComment = () => setShowComment(false);
  const handleShowComment = () => setShowComment(true);
  const pageSizes = [25, 50, 100];
  const [logData, setLogData] = useState([]);
  const [commentData, setCommentData] = useState([]);
  const [GET_CHECK_DATE, SET_CHECK_DATE] = useState("1");
  const [GET_ORDER_ID, SET_ORDER_ID] = useState("");
  const groupedOptions = [
    {
      label: "DELAY PROCESS",
      options: [
        { value: "BOOKING DESK", label: "BOOKING DESK" },
        { value: "CS", label: "CS" },
      ],
    },
    {
      label: "WAIT CONFIRM BOOKING",
      options: [
        { value: "SALES", label: "SALES" },
        { value: "AGENT", label: "AGENT" },
        { value: "SHIPPER", label: "SHIPPER" },
        { value: "CONSIGNEE", label: "CONSIGNEE" },
      ],
    },
  ];
  const [selectedOption, setSelectedOption] = useState(null);
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const onValueChangedDateFrom = React.useCallback((e) => {
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);
  useEffect(() => {
    setResult("");
    if (getUserRole == 6) {
    } else if (getUserRole == 11) {
      setSelectCS(getCrmId);
      setCS({ CS_ID: getCrmId, CS_EMAIL: getUserID });
    } else {
      setSelectCS(getCrmId);
      setCS({ CS_ID: getCrmId, CS_EMAIL: getUserID });
    }
  }, []);
  const styles = {
    radioButton: {
      padding: "12px 16px",
      borderRadius: "8px",
      margin: "8px",
      border: "2px solid #007BFF",
      background: "#fff",
      display: "inline",
      alignItems: "center",
      justifyContent: "center",
      width: "280px",
      cursor: "pointer",
      transition: "background-color 0.3s, color 0.3s",
    },
    selected: {
      background: "#007BFF",
      color: "#fff",
      borderColor: "#007BFF",
    },
    list: {
      listStyleType: "none",
      padding: 0,
      textAlign: "center",
      display: "inline-flex",
    },
  };
  const urlJobManagementReport = useMemo(() => {
    return (
      api_path +
      "/GET_SALES_ORDER_REPORT.php?sale=" +
      selectSale +
      "&cs=" +
      selectCS +
      "&crmid=" +
      getCrmId +
      "&parDateFrom=" +
      getDateFrom +
      "&parDateTo=" +
      getDateTo +
      "&cdate=" +
      GET_CHECK_DATE +
      "&load=" +
      getLoadGrid
    );
  }, [
    selectSale,
    selectCS,
    getCrmId,
    getDateFrom,
    getDateTo,
    GET_CHECK_DATE,
    getLoadGrid,
  ]);

  useEffect(() => {
    setJobManagementReportDataSource(
      new createStore({
        key: "ORDER_ID",
        loadUrl: urlJobManagementReport,
      })
    );
  }, [urlJobManagementReport]);
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  useEffect(() => {
    const getSalesDropdown = async () => {
      try {
        const resstate = await fetch(
          `${api_path}/GET_SALES.php?role=${getUserRole}&user=${getCrmId}`
        );
        const getst = await resstate.json();
        setSaleList(getst);
      } catch (error) {
        console.error("❌ Error fetching sales dropdown:", error);
      }
    };

    if (getUserRole && getCrmId) {
      getSalesDropdown();
    }
  }, [getUserRole, getCrmId]); // ✅ รีเฟรชเมื่อ role หรือ user เปลี่ยน

  const handleSaleChange = (obj) => {
    setSelectSale(obj.SALE_CODE);
    setSale({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });
  };

  useEffect(() => {
    const getCSDropdown = async () => {
      try {
        const resstate = await fetch(
          `${api_path}/GET_CS.php?role=${getUserRole}&user=${getCrmId}&flag=jobreport`
        );
        const getst = await resstate.json();
        setCSList(getst);
      } catch (error) {
        console.error("❌ Error fetching CS dropdown:", error);
      }
    };

    if (getUserRole && getCrmId) {
      getCSDropdown();
    }
  }, [getUserRole, getCrmId]); // ✅ รีเฟรชเมื่อ role หรือ user เปลี่ยน

  const handleCSChange = (obj) => {
    setSelectCS(obj.CS_ID);
    setCS({ CS_ID: obj.CS_ID, CS_EMAIL: obj.CS_EMAIL });
  };

  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "JobKpiReport.xlsx"
        );
      });
    });
  };
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "KPIBookingReleased4hrs") {
        if (
          e.data.KPIBookingReleased4hrs === null ||
          e.data.KPIBookingReleased4hrs === undefined
        ) {
          e.cellElement.innerHTML = "-";
          e.cellElement.style.cssText = "text-align:center;color:black;";
        } else {
          if (e.data.KPIBookingReleased4hrs > 4) {
            e.cellElement.innerHTML = e.data.KPIBookingReleased4hrs + " hrs.";
            e.cellElement.style.cssText = "text-align:center;color:red;";
          } else {
            e.cellElement.innerHTML = e.data.KPIBookingReleased4hrs + " hrs.";
            e.cellElement.style.cssText = "text-align:center;color:green;";
          }
        }
      }
      if (e.column.dataField === "KPIBookingReleased4hrs_Status") {
        if (e.data.KPIBookingReleased4hrs_Status === "Fail") {
          e.cellElement.innerHTML = e.data.KPIBookingReleased4hrs_Status + "❌";
          e.cellElement.style.cssText = "text-align:center;color:red;";
        } else {
          e.cellElement.innerHTML = e.data.KPIBookingReleased4hrs_Status + "✔️";
          e.cellElement.style.cssText = "text-align:center;color:green;";
        }
      }
          if (e.column.dataField === "KPIJobLeadtime24hrs_Status") {
        if (e.data.KPIJobLeadtime24hrs_Status === "Fail") {
          e.cellElement.innerHTML = e.data.KPIJobLeadtime24hrs_Status + "❌";
          e.cellElement.style.cssText = "text-align:center;color:red;";
        } else {
          e.cellElement.innerHTML = e.data.KPIBookingReleased4hrs_Status + "✔️";
          e.cellElement.style.cssText = "text-align:center;color:green;";
        }
      }
      if (e.column.dataField === "CarrierReleaseToSalesConfirm") {
        if (
          e.data.CarrierReleaseToSalesConfirm === null ||
          e.data.CarrierReleaseToSalesConfirm === undefined
        ) {
          e.cellElement.innerHTML = "-";
        } else {
          e.cellElement.innerHTML =
            e.data.CarrierReleaseToSalesConfirm + " hrs.";
        }
        e.cellElement.style.cssText = "text-align:center;color:black;";
      }
      if (e.column.dataField === "KPIBookingReleased") {
        if (
          e.data.KPIBookingReleased === null ||
          e.data.KPIBookingReleased === undefined
        ) {
          e.cellElement.innerHTML = "-";
        } else {
          e.cellElement.innerHTML = e.data.KPIBookingReleased + " hrs.";
        }
        e.cellElement.style.cssText = "text-align:center;color:black;";
      }

      if (e.column.dataField === "SendOrderToReceived") {
        if (
          e.data.SendOrderToReceived === null ||
          e.data.SendOrderToReceived === undefined
        ) {
          e.cellElement.innerHTML = "-";
        } else {
          e.cellElement.innerHTML = e.data.SendOrderToReceived + " hrs.";
        }
        e.cellElement.style.cssText = "text-align:center;color:black;";
      }
      if (e.column.dataField === "SendOrdertoBseRelease") {
        if (
          e.data.SendOrdertoBseRelease === null ||
          e.data.SendOrdertoBseRelease === undefined
        ) {
          e.cellElement.innerHTML = "-";
        } else {
          e.cellElement.innerHTML = e.data.SendOrdertoBseRelease + " hrs.";
        }
        e.cellElement.style.cssText = "text-align:center;color:black;";
      }
      if (e.column.dataField === "BseCreateToBseRelease") {
        if (
          e.data.BseCreateToBseRelease === null ||
          e.data.BseCreateToBseRelease === undefined
        ) {
          e.cellElement.innerHTML = "-";
        } else {
          e.cellElement.innerHTML = e.data.BseCreateToBseRelease + " hrs.";
        }
        e.cellElement.style.cssText = "text-align:center;color:black;";
      }

      if (e.column.dataField === "ORDER_NO") {
        e.cellElement.innerHTML =
          "<p style='color: #000;background-color: #EBEBEB;text-align:center;margin:8px;'><a href='SalesOrderDetail?order_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #000;'>" +
          e.data.ORDER_NO +
          "</a></p>";
      }
    }
  };

  const cellPreparedLog = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "STATUS") {
        e.cellElement.innerHTML =
          "<p class='status" + e.data.STATUS_ID + "'>" + e.data.STATUS + "</p>";
      }
    }
  };

  const [mode, setMode] = useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = useState(true);
  const [allowSelectAll, setAllowSelectAll] = useState(true);
  const [selectByClick, setSelectByClick] = useState(true);
  const [recursive, setRecursive] = useState(true);
  //end column chooser
  const Search = () => {
    const [showResults, setShowResults] = useState(false);
    const onClick = () => setShowResults(true);
    return (
      <div>
        <input type="button" value="Search" onClick={onClick} />
        {showResults ? <Results /> : null}
      </div>
    );
  };
  const Results = () => (
    <div id="results" className="search-results">
      Some Results
    </div>
  );
  // useCallback เป็น React Hook ที่ใช้สำหรับการสร้าง function ที่มีการ caching ใน memory
  // ค่าที่ return จาก useCallback จะไม่เปลี่ยนจนกว่า dependencies ใน array ที่ระบุไว้ให้จะเปลี่ยนแปลง
  // ซึ่งมีประโยชน์ในการประหยัด performance เมื่อมีการ render ซ้ำ ๆ
  const onRefreshClick = useCallback(() => {
    setLoadGrid(randomNumberInRange(1, 20));
  }, []);

  function onShowCommentClick(e) {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    fetchOrderStatus();
    SET_ORDER_ID(e.row.key);
    setShowComment(true);
    fetchCommentData(e.row.key);
  }

  const showCommentData = true;
  const fetchCommentData = async (ORDER_ID) => {
    const response = await fetch(
      api_path + "/GET_COMMENT_KPI_REPORT.php?ORDER_ID=" + ORDER_ID
    );
    const data = await response.json();
    setCommentData(data);
  };
  function DisplayCommentData(props) {
    if (props.commentData.length > 0) {
      return (
        <table class="table table-Default table-hover">
          <thead>
            <tr>
              <th scope="col">DATE</th>
              <th scope="col">By</th>
              <th scope="col">REASON</th>
              <th scope="col">REMARK</th>
            </tr>
          </thead>
          {showCommentData ? (
            <>
              {commentData.map((fdata) => {
                return (
                  <tbody>
                    <tr>
                      <td width={100}>
                        {" "}
                        {dateFormat(
                          fdata.INSERT_DATE,
                          "dd-mmm-yyyy h:MM:ss TT"
                        )}
                      </td>

                      <td width={100}>
                        <b>{fdata.USER_FIRSTNAME}</b>
                      </td>
                      <td>{fdata.REASON} </td>
                      <td>{fdata.REMARK}</td>
                    </tr>
                  </tbody>
                );
              })}
            </>
          ) : (
            <p>You cannot see the data</p>
          )}
        </table>
      );
    } else {
    }
  }
  function onShowlogButtonClick(e) {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    fetchItemData(e.row.key);
    setShowLog(true);
  }

  const showLogData = true;
  const fetchItemData = async (ORDER_ID) => {
    const response = await fetch(
      api_path + "/GET_ORDER_LOG.php?ORDER_ID=" + ORDER_ID
    );
    const data = await response.json();
    setLogData(data);
  };
  function DisplayLogData(props) {
    if (props.logData.length > 0) {
      return (
        <table class="table table-Default table-hover">
          <thead>
            <tr>
              <th scope="col">STATUS</th>
              <th scope="col">DATE</th>
              <th scope="col"></th>
              <th scope="col">Modified By</th>
              <th scope="col">DETAIL</th>
              <th scope="col">REMARK</th>
            </tr>
          </thead>
          {showLogData ? (
            <>
              {logData.map((fdata) => {
                return (
                  <OrderLogDataView
                    key={fdata.INQUIRY_ITEM_ID}
                    id={fdata.ORDER_ID}
                    STATUS_ID={fdata.STATUS_ID}
                    STATUS={fdata.STATUS}
                    USERNAME={fdata.USERNAME}
                    EVENT_DATE={fdata.EVENT_DATE}
                    DATE_TEXT={fdata.DATE_TEXT}
                    REMARK={fdata.REMARK}
                    REVISED_COLUMNS={fdata.REVISED_COLUMNS}
                  />
                );
              })}
            </>
          ) : (
            <p>You cannot see the data</p>
          )}
        </table>
      );
    } else {
    }
  }

  const fetchOrderStatus = () => {
    axios
      .get(api_path + `/MS_INQUIRY_MASTER.php?type=CS_KPI_REASON`)
      .then((response) => {
        setOrderStatusList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleOrderStatusChange = (obj) => {
    setSelectOrderStatus(obj.INQUIRY_MASTER_VALUE);
    setOrderStatus({
      INQUIRY_MASTER_VALUE: obj.INQUIRY_MASTER_VALUE,
      INQUIRY_MASTER_EN: obj.INQUIRY_MASTER_EN,
    });
  };
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const errors = {};
    if (!REMARK) {
      errors.remarkErr = "Required";
    }
    // if (getOrderStatus.INQUIRY_MASTER_EN === "OTHERS") {
    //   if (!REMARK) {
    //     errors.remarkErr = "Required";
    //   }
    // }
    return errors;
  };
  function updateOrder(ORDER_ID, REMARK, USER_ID) {
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      //alert("Invalid")
    } else {
      var data = {
        ORDER_ID: ORDER_ID,
        REMARK: REMARK,
        REASON_NAME: getOrderStatus.INQUIRY_MASTER_EN,
        USER_ID: USER_ID,
      };
      fetch(api_path + "/TS_SALES_ORDER_COMMENT.php", {
        method: "POST",
        headers: {
          Accept: "application/form-data",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result["status"] == "200") {
            swal("Done.", "Save data successfully.", "success", {
              buttons: true,
              timer: 5000,
            }).then(function () {
              handleCloseComment();
              setLoadGrid(randomNumberInRange(1, 20));
            });
          } else {
            swal("Sorry", result["message"], "error", {
              buttons: true,
              timer: 1000,
            });
          }
        });
    }
  }
  const isChecked = (value) => radioRoleStatus === value;
  const [radioRoleStatus, setRadioStatus] = useState("1");
  const handleRadioChange = (event) => {
    setRadioStatus(event.target.value);
    if (event.target.value == "1") {
      //etd
      SET_CHECK_DATE("1");
    } else if (event.target.value == "2") {
      //so date
      SET_CHECK_DATE("2");
    }
  };
  const [modeSize, setModeSize] = useState("widget");
  return (
    <Container maxWidth="xl">
      <Modal
        className="modal"
        show={showLog}
        onHide={handleCloseLog}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Sales Order Log</Modal.Title>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Header>
        <Modal.Body>
          <Grid container>
            <br />
            <DisplayLogData logData={logData} />
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Footer>
      </Modal>

      <Modal
        className="modal"
        show={showComment}
        onHide={handleCloseComment}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Comment</Modal.Title>
          <Button1 variant="secondary" onClick={handleCloseComment}>
            Close
          </Button1>
        </Modal.Header>
        <Modal.Body>
          <Grid container>
            <br />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                updateOrder(GET_ORDER_ID, REMARK, getCrmId);
              }}
              id="editmodal"
              className=""
            >
              <input type="hidden" value={GET_ORDER_ID} />

              <label>
                REASON:
                {/* <Select
                  
        options={groupedOptions}
        value={selectedOption}
        onChange={setSelectedOption}
        placeholder="Select..."
      /> */}
                <Select
                  styles={{
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  placeholder="Select..."
                  value={getOrderStatus}
                  options={orderStatusList}
                  onChange={handleOrderStatusChange}
                  getOptionLabel={(x) => x.INQUIRY_MASTER_EN}
                  getOptionValue={(x) => x.INQUIRY_MASTER_VALUE}
                  required
                />
              </label>
              <br />
              <label>Remark:</label>
              <br />
              <textarea
                id="txtArea"
                rows="3"
                cols="70"
                value={REMARK}
                onChange={(e) => SET_REMARK(e.target.value)}
                inputProps={{ maxLength: 250 }}
              ></textarea>
              {errors.remarkErr && (
                <span className="error-message">{errors.remarkErr}</span>
              )}
            </form>
            <DisplayCommentData commentData={commentData} />
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseComment}>
            Cancel
          </button>
          <button className="btn btn-primary" form="editmodal">
            Save
          </button>
        </Modal.Footer>
      </Modal>
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <label className="head">
            Job Management KPI <PendingActionsIcon fontSize="large" />
          </label>
        </Grid>
        <Grid item xs={12} sm={6}></Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <br />
          <RadioButton
            name="CHECK_DATE"
            value="1"
            text="ETD DATE"
            onChange={handleRadioChange}
            checked={isChecked("1")}
          />
          <RadioButton
            name="CHECK_DATE"
            value="2"
            text="SO DATE"
            onChange={handleRadioChange}
            checked={isChecked("2")}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>From</label>
          <DateBox
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateFrom}
            onValueChanged={onValueChangedDateFrom}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>To</label>
          <DateBox
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateTo}
            min={getMinDate}
            onValueChanged={onValueChangedDateTo}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>CS</label>
          <Select
            className="multiselect1"
            placeholder="Select..."
            value={getCS}
            options={CSList}
            onChange={handleCSChange}
            getOptionLabel={(x) => x.CS_EMAIL}
            getOptionValue={(x) => x.CS_ID}
            required
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>SALES</label>
          <Select
            className="multiselect2"
            placeholder="Select..."
            value={getSale}
            options={saleList}
            onChange={handleSaleChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
            required
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <div className="boxDesc90">
            <label>BKG release 4 hrs. </label>
            <br />
            <label>
              Change status from "Sales confirm" to "Booking released" within 4
              hrs.{" "}
            </label>
          </div>
        </Grid>
        <Grid item xs={12} sm={2}>
          <div className="boxDesc90">
            <label>Carrier Release BKG</label>
            <br />
            <label>
              Change status from "Wait carrier release" to "Sales confirm".{" "}
            </label>
          </div>
        </Grid>
        {/* <Grid item xs={12} sm={4}>
          <div style={{ paddingTop: 7 + "px" }}>&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="info"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>{" "}
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={onRefreshClick}
          >
            Refresh data
          </Button1>
        </Grid> */}
      </Grid>

      <Grid container className={classes.root}>
        <div style={{ width: "100%", overflowX: "auto" }}>
          <DataGrid
            id="JobManagementReportContainer"
            onCellPrepared={cellPrepared}
            dataSource={getJobManagementReportDataSource}
            showBorders={true}
            allowColumnReordering={true}
            allowColumnResizing={true}
            columnResizingMode={modeSize}
            rowAlternationEnabled={true}
            showScrollbar={true}
            keyExpr="ORDER_ID"
            onExporting={onExporting}
            ref={gridRef}
            focusedRowEnabled={true}
            onContentReady={onContentReady}
            height={height}
            repaintChangesOnly={true}
            hoverStateEnabled={true}
          >
            <Scrolling
              rowRenderingMode="virtual"
              showScrollbar="always"
              useNative="false"
              scrollByThumb="true"
            ></Scrolling>
            <StateStoring
              enabled={true}
              type="localStorage"
              storageKey="storageJobManagementReport4"
            />

            <FilterRow visible={true} />
            <FilterPanel visible={true} />
            <HeaderFilter visible={true} />
            <SearchPanel
              visible={true}
              width={240}
              placeholder="Full Text Search..."
            />
            <Column
              dataField="ORDER_ID"
              defaultSortOrder="desc"
              visible={false}
            />
            <Column dataField="ORDER_NO" caption="SO No." width={100} />
            <Column
              dataField="ORDER_DATE"
              caption="SO Date"
              dataType="date"
              format="dd-MMM-yy HH:mm:ss"
              width={120}
              textAlign="center"
            />
            <Column
              dataField="SEND_ORDER"
              caption="SO Sent"
              dataType="date"
              format="dd-MMM-yy HH:mm:ss"
              width={120}
              textAlign="center"
            />
            <Column
              dataField="RECEIVE_DATE"
              caption="SO Received"
              dataType="date"
              format="dd-MMM-yy HH:mm:ss"
              width={120}
              textAlign="center"
            />
            <Column
              dataField="ETD"
              caption="ETD Date"
              dataType="date"
              format="dd-MMM-yy"
              width={100}
              textAlign="center"
            />
            <Column
              dataField="WAITING_FLAG"
              caption="Wait Sales CF?"
              alignment="center"
              width={100}
            />
            <Column
              dataField="WAIT_CARRIER_RELEASE"
              caption="Wait Carrier Release"
              dataType="date"
              format="dd-MMM-yy HH:mm:ss"
              width={120}
            />
            <Column
              dataField="CARRIER_RELEASE"
              caption="Carrier Released"
              dataType="date"
              format="dd-MMM-yy HH:mm:ss"
              width={120}
            />
            <Column
              dataField="WAIT_SALES_CONFIRM"
              caption="Wait Sales Confirm"
              dataType="date"
              format="dd-MMM-yy HH:mm:ss"
              width={120}
            />
            <Column
              dataField="SALES_CONFIRM"
              caption="Sales Confirmed"
              dataType="date"
              format="dd-MMM-yy HH:mm:ss"
              width={120}
            />
            <Column
              dataField="BSE_CREATED"
              caption="BKG Created"
              dataType="date"
              format="dd-MMM-yy HH:mm:ss"
              width={120}
            />
            <Column
              dataField="BSE_RELEASE"
              caption="BKG Released"
              dataType="date"
              format="dd-MMM-yy HH:mm:ss"
              width={120}
            />
            {/* SO Sent to SO Received */}
            <Column
              dataField="SendOrderToReceived"
              caption="SO Leadtime"
              dataType="text"
              width={120}
            />
            {/* Carrier Release to Sales Confirm */}
            <Column
              dataField="CarrierReleaseToSalesConfirm"
              caption="CF Leadtime"
              dataType="text"
              width={120}
            />
            {/* Bse Create to Bse Release */}
            <Column
              dataField="BseCreateToBseRelease"
              caption="BKG Leadtime"
              width={120}
            />
            {/* SO Sent to BSE Release */}
            <Column
              dataField="SendOrdertoBseRelease"
              caption="Job Leadtime"
              width={120}
            />
             <Column
              dataField="KPIJobLeadtime24hrs_Status"
              caption="Leadtime_Status"
              width={100}
              alignment="center" // ใช้กับ cell data
              headerCellRender={() => (
                <div style={{ textAlign: "center", width: "100%" }}>Status</div>
              )}
            />
            <Column
              dataField="KPIBookingReleased4hrs"
              caption="BKG released 4 hrs"
              width={140}
            />
            <Column
              dataField="KPIBookingReleased4hrs_Status"
              caption="Status"
              width={100}
              alignment="center" // ใช้กับ cell data
              headerCellRender={() => (
                <div style={{ textAlign: "center", width: "100%" }}>Status</div>
              )}
            />

            <Column dataField="REASON_KPI" caption="REASON" width={100}/>
            <Column dataField="REMARK_KPI" caption="REMARK" width={150}/>
            <Column dataField="SALES" width={100} />
            <Column dataField="CS_NAME" caption="CS" width={100} />
            <Column dataField="BKG_NAME" caption="BKG" width={100}/>
            <Column type="buttons" caption="Actions" width={100}>
              <Button
                icon="comment"
                onClick={onShowCommentClick}
                hint="Click to update comment"
              />
              <Button
                icon="eyeopen"
                onClick={onShowlogButtonClick}
                hint="Click to view log details"
              />
            </Column>
            <Summary>
              <TotalItem
                column="KPIBookingReleased4hrs_Status"
                summaryType="count"
              />

              {/* <TotalItem
        column="SaleAmount"
        summaryType="sum"
        valueFormat="currency"
      /> */}
            </Summary>
            <ColumnChooser enabled={true} mode={mode}>
              <Position
                my="right top"
                at="right bottom"
                of=".dx-datagrid-column-chooser-button"
              />

              <ColumnChooserSearch
                enabled={searchEnabled}
                editorOptions={searchEditorOptions}
              />

              <ColumnChooserSelection
                allowSelectAll={allowSelectAll}
                selectByClick={selectByClick}
                recursive={recursive}
              />
            </ColumnChooser>
            <LoadPanel enabled={true} />
            <Export enabled={true} allowExportSelectedData={true} />
            <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
            <Paging defaultPageSize={25} />
          </DataGrid>
        </div>
      </Grid>
    </Container>
  );
}
